<template>
    <div class="home d-flex">
        <v-container fluid class="d-flex flex-grow-1">
            <v-row dense class="d-flex flex-grow-1">
                <v-col lg="7" md="7" xs="12" cols="12">
                    <v-card
                        outlined
                        class="d-flex flex-column"
                        style="height: 100%"
                        id="positionTable"
                    >
                        <v-card-title
                            style="border-bottom: 1px solid #404040"
                            class="pt-2 pb-2"
                        >
                            <div class="text-left v-card-custom-title-left">
                                {{ $t("lp.lpInfo.currentPosition") }}
                            </div>
                            <div class="text-right v-card-custom-title-right">
                                <v-select
                                    dense
                                    v-model="selectedLp"
                                    :items="activeLP"
                                    :label="$t('lp.lpInfo.selectLp')"
                                    multiple
                                    single-line
                                    style="display: inline-table; width: 300px"
                                    hide-details
                                    class="pt-0 mt-0"
                                    id="lpChange"
                                    :menu-props="{
                                        maxHeight: 800,
                                    }"
                                >
                                    <template v-slot:prepend-item>
                                        <v-list-item
                                            ripple
                                            @mousedown.prevent
                                            @click="toggle"
                                        >
                                            <v-list-item-action>
                                                <v-icon>
                                                    {{ icon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{
                                                        $t(
                                                            "lp.lpInfo.selectAll"
                                                        )
                                                    }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                    <template
                                        v-slot:selection="{ item, index }"
                                    >
                                        <span v-if="index === 0">
                                            <span
                                                v-if="
                                                    selectedLp.length ===
                                                    activeLP.length
                                                "
                                            >
                                                {{ $t("lp.lpInfo.all") }}
                                            </span>
                                            <span v-else>{{ item }}</span>
                                        </span>
                                        <span
                                            v-if="
                                                index === 1 &&
                                                selectedLp.length !==
                                                    activeLP.length
                                            "
                                            class="grey--text text-caption ml-1"
                                        >
                                            (+{{ selectedLp.length - 1 }}
                                            {{ $t("lp.lpInfo.others") }})
                                        </span>
                                    </template>
                                </v-select>

                                <div style="display: inline-table">
                                    <v-btn
                                        small
                                        color="default"
                                        :loading="positionLoading"
                                        @click="refreshPosition"
                                        id="lpRefresh"
                                        ><v-icon>mdi-refresh</v-icon></v-btn
                                    >
                                    <v-menu offset-y dense>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                small
                                                color="default"
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                                id="intervalChange"
                                            >
                                                {{
                                                    positionTimer == 0
                                                        ? $t("common.time.off")
                                                        : positionTimer + "s"
                                                }}
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item
                                                v-for="item in timerOption"
                                                :key="item.value"
                                                v-on:click="
                                                    changeTimer(
                                                        item.value,
                                                        'position'
                                                    )
                                                "
                                            >
                                                <v-list-item-title>{{
                                                    item.name
                                                }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <v-progress-linear
                                        v-show="positionTimer != 0"
                                        style="
                                            position: relative;
                                            height: 3px;
                                            bottom: 3px;
                                        "
                                        :value="positionTimerValue"
                                    ></v-progress-linear>
                                </div>
                                <v-tooltip top v-if="showDownloadButton">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="green"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-1"
                                            @click="startDownload"
                                            >mdi-microsoft-excel</v-icon
                                        ><download-excel
                                            id="csvExport"
                                            :fetch="fetchData"
                                            :fields="positionCsvFields"
                                            type="csv"
                                            style="display: none"
                                            name="LP_Current_position.csv"
                                            :escapeCsv="false"
                                        >
                                        </download-excel>
                                    </template>
                                    <span>{{
                                        $t("lp.lpInfo.downloadCurrentPosition")
                                    }}</span>
                                </v-tooltip>
                            </div>
                        </v-card-title>
                        <v-data-table
                            v-model="selectedSymbols"
                            class="flex-grow-1"
                            dense
                            :headers="positionHeader"
                            :items="lpPositionData"
                            item-key="id"
                            :loading="positionLoading"
                            :loading-text="$t('lp.eodPosition.loadingText')"
                            :items-per-page="-1"
                            :height="tableHeight"
                            :hide-default-footer="true"
                            fixed-header
                            :header-props="{ sortIcon: null }"
                            :customSort="customSort"
                            :sort-by.sync="positionSortBy"
                            :sort-desc.sync="positionSortDesc"
                        >
                            <template v-slot:header.Symbol="{ header }">
                                {{ header.text }}
                                <v-menu
                                    offset-y
                                    :close-on-content-click="false"
                                    top
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.prevent="
                                                onSearch('symbolSearch')
                                            "
                                        >
                                            mdi-magnify
                                        </v-icon>
                                    </template>
                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 280px;
                                        "
                                    >
                                        <v-text-field
                                            v-model="search"
                                            class="px-4"
                                            type="text"
                                            ref="symbolSearch"
                                            :label="
                                                $t(
                                                    'common.phrase.enterSearchTerm'
                                                ) + 'shit'
                                            "
                                            style="width: 100%"
                                            single-line
                                            hide-details
                                        ></v-text-field>
                                        <v-btn
                                            @click="search = ''"
                                            small
                                            text
                                            color="primary"
                                            class="ml-2 mb-2"
                                            style="padding: 6px"
                                        >
                                            {{ $t("common.form.clean") }}
                                        </v-btn>
                                    </div>
                                </v-menu>
                            </template>

                            <template v-slot:item="{ item }">
                                <tr>
                                    <td
                                        column="lp"
                                        class="fixCol_first"
                                        style="white-space: nowrap"
                                    >
                                        {{ item.LP.toUpperCase() }}
                                    </td>
                                    <td column="Symbol">
                                        <span
                                            v-if="item.isSelectable != true"
                                            >{{ item.Symbol }}</span
                                        >

                                        <v-tooltip bottom v-else>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <a
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    style="color: red"
                                                    @click="
                                                        selectedSymbols.push(
                                                            item
                                                        );
                                                        handleAddSymbol(
                                                            item.LP
                                                        );
                                                    "
                                                >
                                                    {{ item.Symbol }}
                                                </a>
                                            </template>
                                            <span>{{
                                                $t(
                                                    "lp.lpInfo.actionRequiredToMap"
                                                )
                                            }}</span>
                                        </v-tooltip>
                                    </td>
                                    <td column="Margin_Rate" align="right">
                                        {{
                                            item["Margin Rate"] === "N/A"
                                                ? item["Margin Rate"]
                                                : parseInt(
                                                      item["Margin Rate"] * 100
                                                  ) + "%"
                                        }}
                                    </td>
                                    <td column="Position" align="right">
                                        {{
                                            item.Position === "N/A"
                                                ? item.Position
                                                : numberWithCommas(
                                                      parseFloat(
                                                          item.Position
                                                      ).toFixed(2)
                                                  )
                                        }}
                                    </td>
                                    <td column="Total_VWAP" align="right">
                                        {{
                                            item["Total VWAP"] === "N/A"
                                                ? item["Total VWAP"]
                                                : item["Total VWAP"].toFixed(
                                                      item["digits"]
                                                  )
                                        }}
                                    </td>
                                    <td column="Margin" align="right">
                                        {{
                                            item.Margin === "N/A"
                                                ? item.Margin
                                                : numberWithCommas(
                                                      parseFloat(
                                                          item.Margin
                                                      ).toFixed(2)
                                                  )
                                        }}
                                    </td>
                                    <td column="NOP" align="right">
                                        {{
                                            item.NOP
                                                ? numberWithCommas(
                                                      item.NOP.toFixed(2)
                                                  )
                                                : "0.00"
                                        }}
                                    </td>
                                    <td
                                        column="Unrealized_PNL_CCY_Account"
                                        align="right"
                                    >
                                        {{
                                            item[
                                                "Margin Unrealized P&L in Account CCY"
                                            ] === "N/A"
                                                ? item[
                                                      "Margin Unrealized P&L in Account CCY"
                                                  ]
                                                : numberWithCommas(
                                                      parseFloat(
                                                          item[
                                                              "Margin Unrealized P&L in Account CCY"
                                                          ]
                                                      ).toFixed(2)
                                                  )
                                        }}
                                    </td>
                                    <td
                                        column="Unrealized_PNL_CCY_Quote"
                                        align="right"
                                    >
                                        {{
                                            item[
                                                "Unrealized P&L in Quote CCY"
                                            ] === "N/A"
                                                ? item[
                                                      "Unrealized P&L in Quote CCY"
                                                  ]
                                                : numberWithCommas(
                                                      parseFloat(
                                                          item[
                                                              "Unrealized P&L in Quote CCY"
                                                          ]
                                                      ).toFixed(2)
                                                  )
                                        }}
                                    </td>
                                    <td
                                        column="last_update"
                                        class="fixCol_last"
                                    >
                                        {{ item.updated_at }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
                <v-col lg="5" md="5" xs="12" cols="12">
                    <v-card
                        outlined
                        class="d-flex flex-column"
                        style="height: 100%"
                        id="accountTable"
                    >
                        <v-card-title
                            style="border-bottom: 1px solid #404040"
                            class="pt-2 pb-2"
                        >
                            <div class="text-left v-card-custom-title-left">
                                {{ $t("lp.lpInfo.accountInfo") }}
                            </div>
                            <div class="text-right v-card-custom-title-right">
                                <div
                                    style="display: inline-table"
                                    id="accountFunctions"
                                >
                                    <v-btn
                                        small
                                        color="default"
                                        :loading="accountLoading"
                                        @click="refreshAccount"
                                        ><v-icon>mdi-refresh</v-icon></v-btn
                                    >
                                    <v-menu offset-y dense>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                small
                                                color="default"
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{
                                                    accountTimer == 0
                                                        ? $t("common.time.off")
                                                        : accountTimer + "s"
                                                }}
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item
                                                v-for="item in timerOption"
                                                :key="item.value"
                                                v-on:click="
                                                    changeTimer(
                                                        item.value,
                                                        'account'
                                                    )
                                                "
                                            >
                                                <v-list-item-title>{{
                                                    item.name
                                                }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <v-progress-linear
                                        v-show="accountTimer != 0"
                                        style="
                                            position: relative;
                                            height: 3px;
                                            bottom: 3px;
                                        "
                                        :value="accountTimerValue"
                                    ></v-progress-linear>
                                </div>
                                <v-tooltip top v-if="showDownloadButton">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="green"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-1"
                                            @click="accountDownload"
                                            >mdi-microsoft-excel</v-icon
                                        ><download-excel
                                            id="accountCsvExport"
                                            :fetch="fetchAccountData"
                                            :fields="accountCsvField"
                                            type="csv"
                                            style="display: none"
                                            name="LP_Account_info.csv"
                                            :escapeCsv="false"
                                        >
                                        </download-excel>
                                    </template>
                                    <span>{{
                                        $t("lp.lpInfo.downloadCurrentPosition")
                                    }}</span>
                                </v-tooltip>
                            </div>
                        </v-card-title>

                        <v-data-table
                            class="flex-grow-1"
                            dense
                            :headers="accountHeader"
                            :items="filteredAccountData"
                            :loading="accountLoading"
                            :loading-text="$t('lp.eodPosition.loadingText')"
                            :items-per-page="-1"
                            :height="tableHeight"
                            :hide-default-footer="true"
                            fixed-header
                            :customSort="customSort"
                            :sort-by.sync="accountSortBy"
                            :sort-desc.sync="accountSortDesc"
                            :header-props="{ sortIcon: null }"
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td column="lp" class="fixCol_first">
                                        <span style="white-space: nowrap">
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        style="
                                                            color: red;
                                                            margin-right: 5px;
                                                        "
                                                        size="15"
                                                        v-if="isWorkingDay"
                                                        v-show="
                                                            isOutsideOfTimeOffset(
                                                                item.updated_at
                                                            )
                                                        "
                                                    >
                                                        mdi-alert
                                                    </v-icon>
                                                </template>
                                                <span
                                                    >{{
                                                        $t(
                                                            "lp.lpInfo.accountNotUpToDate"
                                                        )
                                                    }}
                                                    {{ item.updated_at }}</span
                                                >
                                            </v-tooltip>

                                            {{ item.LP.toUpperCase() }}
                                        </span>
                                    </td>
                                    <td column="Margin%" align="right">
                                        <div
                                            :style="
                                                'color:' +
                                                (item['Margin Utilization %'] >
                                                    50 ||
                                                item['Margin Utilization %'] < 0
                                                    ? 'red'
                                                    : 'white')
                                            "
                                        >
                                            {{
                                                item[
                                                    "Margin Utilization %"
                                                ].toFixed(2) + "%"
                                            }}
                                        </div>
                                    </td>
                                    <td column="Used" align="right">
                                        {{
                                            numberWithCommas(
                                                parseFloat(item.Margin).toFixed(
                                                    2
                                                )
                                            )
                                        }}
                                    </td>
                                    <td column="Free" align="right">
                                        {{
                                            numberWithCommas(
                                                item["Free Margin"].toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td column="Equity" align="right">
                                        {{
                                            numberWithCommas(
                                                item.Equity.toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td column="FPNL" align="right">
                                        {{
                                            numberWithCommas(
                                                item["Unrealized P&L"].toFixed(
                                                    2
                                                )
                                            )
                                        }}
                                    </td>
                                    <td column="Balance" align="right">
                                        {{
                                            numberWithCommas(
                                                item.Balance.toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td column="Credit" align="right">
                                        {{
                                            item.Credit == null
                                                ? null
                                                : numberWithCommas(
                                                      parseFloat(
                                                          item.Credit
                                                      ).toFixed(2)
                                                  )
                                        }}
                                    </td>
                                    <td
                                        class="fixCol_last"
                                        column="Last Update"
                                    >
                                        {{ item.updated_at }}
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:body.append>
                                <tr class="summary-row">
                                    <td class="fixCol_first">
                                        <strong>{{
                                            $t("lp.lpInfo.total")
                                        }}</strong>
                                    </td>
                                    <td></td>
                                    <td align="right">
                                        {{
                                            numberWithCommas(
                                                summaryData["Margin"].toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td align="right">
                                        {{
                                            numberWithCommas(
                                                summaryData[
                                                    "Free_Margin"
                                                ].toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td align="right">
                                        {{
                                            numberWithCommas(
                                                summaryData["Equity"].toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td align="right">
                                        {{
                                            numberWithCommas(
                                                summaryData[
                                                    "Unrealized_PNL"
                                                ].toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td align="right">
                                        {{
                                            numberWithCommas(
                                                summaryData["Balance"].toFixed(
                                                    2
                                                )
                                            )
                                        }}
                                    </td>
                                    <td align="right">
                                        {{
                                            numberWithCommas(
                                                summaryData["Credit"].toFixed(2)
                                            )
                                        }}
                                    </td>
                                    <td class="fixCol_last"></td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { permission } from "@components/mixins/permission";
import { helper } from "@components/mixins/helper";
import { snackbar } from "@components/mixins/snackbar";
import common from "@assets/js/common";
import deepClone from "deep-clone";

export default {
    mixins: [permission, helper, snackbar],
    props: {
        tableHeight: Number,
    },
    data() {
        return {
            search: "",
            selectedLp: [],
            loadTable: false,
            timeOffset: 1000 * 60,
            selectedSymbols: [],
            positionTimer: 0,
            accountTimer: 0,
            timerOption: [
                { name: this.$t("common.time.off"), value: 0 },
                { name: this.$t("common.time.15s"), value: 15 },
                { name: this.$t("common.time.30s"), value: 30 },
            ],
            positionTimeInterval: null,
            accountTimeInterval: null,
            positionTimerValue: 0,
            accountTimerValue: 0,
            hardRefresh: null,
            summaryData: {
                Margin: 0,
                Free_Margin: 0,
                Equity: 0,
                Unrealized_PNL: 0,
                Balance: 0,
                Credit: 0,
            },
            accountSortBy: "",
            accountSortDesc: "",
            positionSortBy: "",
            positionSortDesc: "",
            sortMap: {
                Unrealized_PNL: "Unrealized P&L",
                Credit: "Credit",
                Balance: "Balance",
                Equity: "Equity",
                Free_Margin: "Free Margin",
                Margin: "Margin",
                Margin_Utilization: "Margin Utilization %",
                updated_at: "updated_at",
                // Unrealized_PNL_CCY_Quote: "Unrealized P&L in Quote CCY",
                // Unrealized_PNL_CCY_Account:
                //     "Margin Unrealized P&L in Account CCY",
                // Total_VWAP: "Total VWAP",
                Position: "Position",
                Margin_Rate: "Margin Rate",
                NOP: "NOP",
            },
            showDownloadButton: false,
        };
    },
    watch: {
        /**
         * Watch on lplist change
         * @param   {[type]}  nv  [nv description]
         * @return  {[type]}      [return description]
         */
        lpList(nv) {
            if (nv.length !== 0) {
                const lpSelection = JSON.parse(
                    localStorage.getItem("lp-selection")
                );
                if (!!lpSelection) {
                    this.selectedLp = lpSelection;
                } else {
                    this.selectedLp = this.activeLP;
                }

                this.getLPAccountAction();
                this.getLPPositionAction();
            }
        },
        positionTimer(nv) {
            if (nv == 0) {
                clearInterval(this.positionTimeInterval);
            } else {
                clearInterval(this.positionTimeInterval);
                this.positionTimerValue = 0;
                this.positionTimeInterval = setInterval(() => {
                    if (this.positionTimerValue >= 100) {
                        this.positionTimerValue -= 100;
                        this.getLPPositionAction();
                    } else {
                        this.positionTimerValue += 10 / this.positionTimer;
                    }
                }, 100);
            }
        },
        accountTimer(nv) {
            if (nv == 0) {
                clearInterval(this.accountTimeInterval);
            } else {
                clearInterval(this.accountTimeInterval);
                this.accountTimerValue = 0;
                this.accountTimeInterval = setInterval(() => {
                    if (this.accountTimerValue >= 100) {
                        this.accountTimerValue -= 100;
                        this.getLPAccountAction();
                    } else {
                        this.accountTimerValue += 10 / this.accountTimer;
                    }
                }, 100);
            }
        },
    },
    computed: {
        ...mapState("LP", [
            "accountHeader",
            "accountData",
            "positionHeader",
            "positionData",
            "lpList",
            "accountLoading",
            "positionLoading",
            "positionCsvFields",
            "accountCsvField",
        ]),
        isWorkingDay() {
            return common.isWeekday();
        },
        icon() {
            if (this.selectedLp.length === this.activeLP.length)
                return "mdi-close-box";
            if (
                this.selectedLp.length > 0 &&
                this.selectedLp.length < this.activeLP.length
            )
                return "mdi-minus-box";
            return "mdi-checkbox-blank-outline";
        },
        activeLP() {
            let result = [];
            this.lpList.map((item) => {
                if (item.active === 1) {
                    result.push(item.lp_name.toUpperCase());
                }
            });

            return result;
        },
        filteredAccountData() {
            let result = [];
            const summaryData = {
                Margin: 0,
                Free_Margin: 0,
                Equity: 0,
                Unrealized_PNL: 0,
                Balance: 0,
                Credit: 0,
            };
            this.accountData.map((item) => {
                if (
                    this.activeLP.includes(item.LP.toUpperCase())
                ) {
                    result.push(item);
                    summaryData.Margin += parseFloat(item.Margin);
                    summaryData.Free_Margin += parseFloat(item["Free Margin"]);
                    summaryData.Equity += parseFloat(item.Equity);
                    summaryData.Unrealized_PNL += parseFloat(
                        item["Unrealized P&L"]
                    );
                    summaryData.Balance += parseFloat(item.Balance);
                    summaryData.Credit += parseFloat(item.Credit);
                }
            });
            this.summaryData = summaryData;
            return result;
        },
        lpPositionData() {
            return this.positionData
                .filter(
                    (item) =>
                        this.selectedLp.includes(item.LP.toUpperCase()) &&
                        item.Symbol.toUpperCase().match(
                            this.search.toUpperCase()
                        )
                )
                .map((item) => {
                    item.isSelectable = item.Symbol.split("||").length > 1;
                    return item;
                });
        },
        computedLpPositionData() {
            const copy = deepClone(this.lpPositionData);
            return copy.map((item) => {
                return {
                    LP: item["LP"].toUpperCase(),
                    Symbol: item.Symbol,
                    Margin_Rate:
                        item["Margin Rate"] === "N/A"
                            ? item["Margin Rate"]
                            : parseInt(item["Margin Rate"] * 100) + "%",
                    Position:
                        item.Position === "N/A"
                            ? item.Position
                            : parseFloat(item.Position).toFixed(2),
                    Total_VWAP:
                        item["Total VWAP"] === "N/A"
                            ? item["Total VWAP"]
                            : item["Total VWAP"].toFixed(item["digits"]),
                    Margin:
                        item.Margin === "N/A"
                            ? item.Margin
                            : parseFloat(item.Margin).toFixed(2),
                    NOP: item.NOP ? item.NOP.toFixed(2) : "0.00",
                    Unrealized_PNL_CCY_Account:
                        item["Margin Unrealized P&L in Account CCY"] === "N/A"
                            ? item["Margin Unrealized P&L in Account CCY"]
                            : parseFloat(
                                  item["Margin Unrealized P&L in Account CCY"]
                              ).toFixed(2),
                    Unrealized_PNL_CCY_Quote:
                        item["Unrealized P&L in Quote CCY"] === "N/A"
                            ? item["Unrealized P&L in Quote CCY"]
                            : parseFloat(
                                  item["Unrealized P&L in Quote CCY"]
                              ).toFixed(2),
                    updated_at: item.updated_at,
                };
            });
        },
        computedAccountData() {
            const copy = deepClone(this.filteredAccountData);
            return copy.map((item) => {
                return {
                    LP: item["LP"].toUpperCase(),
                    Margin_Utilization:
                        item["Margin Utilization %"].toFixed(2) + "%",
                    Margin: item["Margin"].toFixed(2),
                    Free_Margin: item["Free Margin"].toFixed(2),
                    Equity: item["Equity"].toFixed(2),
                    Unrealized_PNL: item["Unrealized P&L"].toFixed(2),
                    Balance: item["Balance"].toFixed(2),
                    Credit: item["Credit"].toFixed(2),
                    updated_at: item["updated_at"],
                };
            });
        },
    },
    methods: {
        ...mapActions("LP", ["getLPAccountAction", "getLPPositionAction"]),
        ...mapMutations("LP", ["UPDATE_BATCH_ADD_LP_ID"]),
        /**
         * Refresh Account Data
         * @return  {[type]}  [return description]
         */
        refreshAccount() {
            this.getLPAccountAction();
        },
        refreshPosition() {
            this.getLPPositionAction();
        },
        isOutsideOfTimeOffset(time) {
            if (
                Math.abs(
                    new Date(common.getMT4TimeString()).getTime() -
                        new Date(time).getTime()
                ) < this.timeOffset
            )
                return false;
            return true;
        },
        handleAddSymbol(name) {
            const found = this.lpList.find((lp) => lp.lp_name === name)?.id;
            this.UPDATE_BATCH_ADD_LP_ID(found);
            this.$emit(
                "addSymbol",
                this.selectedSymbols.map((item) => item.Symbol)
            );
        },
        changeTimer(timeInterval, section) {
            if (section == "position") {
                this.positionTimer = timeInterval;
            } else if (section == "account") {
                this.accountTimer = timeInterval;
            }
        },
        onSearch(field) {
            setTimeout(() => {
                this.$refs[field].focus();
            }, 200);
        },
        toggle() {
            this.$nextTick(() => {
                if (this.selectedLp.length === this.activeLP.length) {
                    this.selectedLp = [];
                } else {
                    this.selectedLp = this.activeLP.slice();
                }
            });
        },
        customSort(items, sortBy, sortDesc) {
            items.sort((a, b) => {
                if (sortBy[0] === "Symbol") {
                    if (!sortDesc[0]) return a.Symbol.localeCompare(b.Symbol);
                    if (sortDesc[0]) return b.Symbol.localeCompare(a.Symbol);
                } else if (sortBy[0] === "LP") {
                    if (!sortDesc[0])
                        return (a.LP.split("] ")[1] ?? "").localeCompare(
                            b.LP.split("] ")[1] ?? ""
                        );
                    if (sortDesc[0])
                        return (b.LP.split("] ")[1] ?? "").localeCompare(
                            a.LP.split("] ")[1] ?? ""
                        );
                } else if (
                    [
                        "Unrealized_PNL_CCY_Quote",
                        "Unrealized_PNL_CCY_Account",
                        "Total_VWAP",
                    ].includes(sortBy[0])
                ) {
                    if (!sortDesc[0]) {
                        return a[this.sortMap[sortBy[0]]] <
                            b[this.sortMap[sortBy[0]]]
                            ? -1
                            : 1;
                    } else {
                        return b[this.sortMap[sortBy[0]]] <
                            a[this.sortMap[sortBy[0]]]
                            ? -1
                            : 1;
                    }
                } else {
                    if (!sortDesc[0]) {
                        return a[this.sortMap[sortBy[0]]] <
                            b[this.sortMap[sortBy[0]]]
                            ? -1
                            : 1;
                    } else {
                        return b[this.sortMap[sortBy[0]]] <
                            a[this.sortMap[sortBy[0]]]
                            ? -1
                            : 1;
                    }
                }
            });
            return items;
        },
        startDownload() {
            document.getElementById("csvExport").click();
            console.log(this.lpPositionData);
        },
        accountDownload() {
            document.getElementById("accountCsvExport").click();
            console.log(this.lpPositionData);
        },
        async fetchData() {
            return this.computedLpPositionData;
        },
        async fetchAccountData() {
            return this.computedAccountData;
        },
    },
    created() {
        this.hardRefresh = setInterval(() => {
            this.refreshAccount();
        }, this.timeOffset * 2);

        const permission = JSON.parse(
            localStorage.getItem("permission")
        ).frontPermission;

        if (permission?.lp?.child.includes("lpDownloadAll")) {
            this.showDownloadButton = true;
        } else {
            this.showDownloadButton = false;
        }
    },
    mounted() {
        const lpSelection = JSON.parse(localStorage.getItem("lp-selection"));
        if (!!lpSelection) {
            this.selectedLp = lpSelection;
        }
    },
    beforeDestroy() {
        clearInterval(this.accountTimeInterval);
        clearInterval(this.positionTimeInterval);
        clearInterval(this.hardRefresh);
        localStorage.setItem("lp-selection", JSON.stringify(this.selectedLp));
    },
};
</script>

<style>
.fixCol_last.header {
    z-index: 4 !important;
}
.fixCol_first.header {
    z-index: 4 !important;
}
.fixCol_last {
    position: sticky !important;
    right: 0;
    z-index: 1 !important;
    background-color: #1e1e1e;
}
.fixCol_first {
    position: sticky !important;
    left: 0;
    z-index: 1 !important;
    background-color: #1e1e1e;
}
</style>
